import styles from "../reseller.module.css"

export function HeroSection() {
  return (
    <section className={styles.heroSection}>
      {/* Background gradient orbs */}
      <div className={styles.heroBackground}>
        <div className={styles.orbRed}></div>
        <div className={styles.orbBlue}></div>
      </div>

      <div className={styles.heroContent}>
        {/* Logo/Badge */}
        <div className={styles.heroBadge}>
          <span className="text-2xl">🌙</span>
          <span className={styles.heroBadgeText}>PIXEL MOON STORE</span>
        </div>

        {/* Main heading */}
        <h1 className={styles.heroTitle}>
          RESELLER
          <span className={styles.heroTitleGradient}>GALAXY</span>
        </h1>

        {/* Subheading */}
        <p className={styles.heroSubtitle}>Become a trusted Pixel Moon Store Reseller and start earning globally!</p>

        {/* CTA Button */}
        <button type="button" className={styles.heroButton} onClick={() => window.location.href = 'https://wa.link/oskfd2'}>Join the Galaxy</button>

        {/* Stats */}
        <div className={styles.heroStats}>
          <div className={styles.heroStatItem}>
            <div className={styles.heroStatNumber}>500+</div>
            <div className={styles.heroStatLabel}>Active Resellers</div>
          </div>
          <div className={styles.heroStatItem}>
            <div className={styles.heroStatNumber}>150+</div>
            <div className={styles.heroStatLabel}>Countries</div>
          </div>
          <div className={styles.heroStatItem}>
            <div className={styles.heroStatNumber}>$2M+</div>
            <div className={styles.heroStatLabel}>Revenue Generated</div>
          </div>
        </div>
      </div>
    </section>
  )
}
